import axios from 'axios'

const api = axios.create({
  withCredentials: true,
  baseURL: process.env.VUE_APP_SERVER_ADDRESS
})

export let unauthorizedInterceptor = null

export function removeUnauthorizedInterceptor() {
  api.interceptors.response.eject(unauthorizedInterceptor)
}

export function addUnauthorizedInterceptor(onUnauthorized){
  unauthorizedInterceptor = api.interceptors.response.use(function (response) {
    return response;
  }, function (error) {
    if (error.response && error.response.status === 401) {
      onUnauthorized()
      return;
    }
    
    return Promise.reject(error);
  });
}

export default api